import { ServiceDto } from './servicedto';
import { rateModelTraductionDto } from './ratemodeltraductiondto';

export class RateModelDto {
    idRateModel?: number;
    codeRateModel?: string;
    serviceDto?: ServiceDto;
    academicFees?: boolean;
    learningResourcesRates?: boolean;
    shippingRates?: boolean;
    administrativeFees?: boolean;
    surcharges?: boolean;
    active?: string;
    typology?: string;
    rateModelTraductionDto?: rateModelTraductionDto[] = [];

    constructor(data?: Partial<RateModelDto>) {
        Object.assign(this, data);
    }


}
